import { OBJECT_TYPE_PAYLOAD_MAP, OBJECT_TYPE_MAP, StatementOperatorTypes } from "../context/CustomField/CustomFieldTypes";
import GroupConditionType, { GroupConditionPayloadTypeArray } from "../types/GroupCondition";
import { SubConditionPayloadType } from "../types/SubCondition";

export const transformPayloadToGroupCondition = (groupConditionPayload: GroupConditionPayloadTypeArray): Array<GroupConditionType> => {
    return groupConditionPayload.map((groupPayload, groupIndex) => ({
        order: groupPayload.orderNumber - 1,
        operator: groupPayload.operator,
        conditions: groupPayload.conditionList.map((subCondition: SubConditionPayloadType, subConditionIndex) => ({
            fieldEId: subCondition.fieldEId,
            objectType: OBJECT_TYPE_PAYLOAD_MAP[subCondition.objectType || ''],
            order: subConditionIndex - 1,
            operator: subCondition.operator,
            statement: {
                values: subCondition.statementContentList.map(statementValue => statementValue.content),
                operator: subCondition.statementOperator,
            }
        }))
    }))
}

export const transformGroupConditionToPayload = (groupConditions: Array<GroupConditionType>): GroupConditionPayloadTypeArray => {
    return groupConditions.map((groupCondition, groupIndex) => ({
        orderNumber: groupIndex + 1,
        operator: groupCondition.operator,
        conditionList: groupCondition.conditions.map((subCondition, subConditionIndex) => ({
            fieldEId: subCondition.fieldEId,
            objectType: OBJECT_TYPE_MAP[subCondition.objectType] === '' ? null : OBJECT_TYPE_MAP[subCondition.objectType],
            orderNumber: subConditionIndex + 1,
            operator: subCondition.operator,
            statementContentList: subCondition.statement.values.map((statementValue) => ({content: statementValue})) as Array<{ content: string }>,
            statementOperator: subCondition.statement.operator as StatementOperatorTypes,
        }))
    }))
}